import { useState } from "react";
import { ShareNetwork, Copy, Check, WhatsappLogo } from "@phosphor-icons/react";
import { track } from "../lib/analytics";
import { toast } from "sonner";

export function ShareTrip({ itinerary }) {
  const [copied, setCopied] = useState(false);

  const tripUrl = `${window.location.origin}/trip/${itinerary.id}`;
  const shortTitle = itinerary.title || `${itinerary.country} trip`;
  const waMessage = `Check out my ${itinerary.country} itinerary on Flycher — "${shortTitle}". Day-by-day plan + budget hotels included: ${tripUrl}`;
  const waUrl = `https://wa.me/?text=${encodeURIComponent(waMessage)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(tripUrl);
      setCopied(true);
      track("share_link_copied", {
        itinerary_id: itinerary.id,
        country: itinerary.country,
      });
      toast.success("Link copied — share it with your travel buddies");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Couldn't copy. Long-press the link instead.");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Flycher — ${shortTitle}`,
          text: `My ${itinerary.country} trip-board on Flycher`,
          url: tripUrl,
        });
        track("share_native", {
          itinerary_id: itinerary.id,
          country: itinerary.country,
        });
      } catch {
        /* user cancelled */
      }
    } else {
      copy();
    }
  };

  return (
    <div
      data-testid="share-trip"
      className="flex flex-wrap items-center gap-2"
    >
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp"
        onClick={() =>
          track("share_whatsapp_clicked", {
            itinerary_id: itinerary.id,
            country: itinerary.country,
          })
        }
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold text-white shadow-md hover:opacity-95"
        style={{ background: "#25D366" }}
      >
        <WhatsappLogo size={16} weight="fill" />
        WhatsApp
      </a>
      <button
        type="button"
        onClick={copy}
        data-testid="share-copy"
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium border border-slate-200 bg-white hover:border-[#2A7FB8]/50 text-slate-700"
      >
        {copied ? (
          <>
            <Check size={14} weight="bold" color="#2D9D78" /> Copied
          </>
        ) : (
          <>
            <Copy size={14} /> Copy link
          </>
        )}
      </button>
      <button
        type="button"
        onClick={nativeShare}
        data-testid="share-native"
        className="md:hidden inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium border border-slate-200 bg-white text-slate-700"
        aria-label="Share"
      >
        <ShareNetwork size={14} /> More
      </button>
    </div>
  );
}
